
/**
 * name: vue3-typer
 * version: v1.0.0
 * description: Vue 3 component that simulates a user typing, selecting, and erasing text.
 * author: CodeSpikeX
 * homepage: https://github.com/codespikex/vue3-typer#readme
 */

import { defineComponent as oe, computed as f, openBlock as N, createElementBlock as U, normalizeClass as Z, toDisplayString as Me, ref as b, unref as G, watch as ne, onMounted as ke, onBeforeUnmount as we, nextTick as de, resolveComponent as ve, createElementVNode as ye, Fragment as he, renderList as ge, createBlock as me, createVNode as Fe } from "vue";
function be(e) {
  return typeof e == "number" && !Number.isNaN(e) && Number.isFinite(e);
}
function Ye(e, r) {
  return be(e) && be(r) && e <= r;
}
function Be(e, r, a) {
  if (r === a)
    return;
  const c = e[r];
  e[r] = e[a], e[a] = c;
}
function Ue(e, r) {
  return Ye(e, r) ? (e = Math.ceil(e), r = Math.floor(r), Math.floor(Math.random() * (r - e + 1)) + e) : -1;
}
function Ve(e, r) {
  if (!Array.isArray(e) || !Array.isArray(r) || e.length !== r.length)
    return !1;
  for (let a = 0; a < e.length; a++)
    if (e[a] !== r[a])
      return !1;
  return !0;
}
function qe(e) {
  if (!(e instanceof Array))
    return e;
  for (let r = e.length - 1; r > 0; r--) {
    let a = Ue(0, r);
    Be(e, r, a);
  }
}
const Ke = oe({
  name: "Char.vue",
  props: {
    char: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return {
      css: f(() => ({
        newline: e.char.indexOf(`
`) === 0
      }))
    };
  }
}), ue = (e, r) => {
  const a = e.__vccOpts || e;
  for (const [c, i] of r)
    a[c] = i;
  return a;
};
function ze(e, r, a, c, i, y) {
  return N(), U("span", {
    class: Z(["char", e.css])
  }, Me(e.char), 3);
}
const He = /* @__PURE__ */ ue(Ke, [["render", ze]]), Je = oe({
  name: "VueTyperCaret",
  props: {
    animation: {
      type: String,
      default: () => "blink",
      validator: (e) => /^solid$|^blink$|^smooth$|^phase$|^expand$/.test(e)
    }
  }
});
function We(e, r, a, c, i, y) {
  return N(), U("span", {
    class: Z(["caret", e.animation])
  }, null, 2);
}
const Xe = /* @__PURE__ */ ue(Je, [["render", We]]);
var X = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
var ae = { exports: {} };
(function(e, r) {
  var a = 1 / 0, c = 9007199254740991, i = 4294967295, y = "[object Function]", d = "[object GeneratorFunction]", s = "[object RegExp]", h = "[object Symbol]", g = /^(?:0|[1-9]\d*)$/, p = "\\ud800-\\udfff", E = "\\u0300-\\u036f\\ufe20-\\ufe23", V = "\\u20d0-\\u20f0", q = "\\ufe0e\\ufe0f", Q = "[" + p + "]", C = "[" + E + V + "]", A = "\\ud83c[\\udffb-\\udfff]", K = "(?:" + C + "|" + A + ")", P = "[^" + p + "]", _ = "(?:\\ud83c[\\udde6-\\uddff]){2}", L = "[\\ud800-\\udbff][\\udc00-\\udfff]", S = "\\u200d", D = K + "?", z = "[" + q + "]?", H = "(?:" + S + "(?:" + [P, _, L].join("|") + ")" + z + D + ")*", M = z + D + H, J = "(?:" + [P + C + "?", C, _, L, Q].join("|") + ")", R = RegExp(A + "(?=" + A + ")|" + J + M, "g"), k = RegExp("[" + S + p + E + V + q + "]"), $ = typeof X == "object" && X && X.Object === Object && X, w = typeof self == "object" && self && self.Object === Object && self, F = $ || w || Function("return this")(), Y = r && !r.nodeType && r, O = Y && !0 && e && !e.nodeType && e, W = O && O.exports === Y, j = W && $.process, B = function() {
    try {
      return j && j.binding("util");
    } catch {
    }
  }(), x = B && B.isRegExp;
  function l(t) {
    return t.split("");
  }
  function v(t) {
    return function(n) {
      return t(n);
    };
  }
  function le(t) {
    return k.test(t);
  }
  function Ee(t) {
    return le(t) ? Se(t) : l(t);
  }
  function Se(t) {
    return t.match(R) || [];
  }
  var Te = Object.prototype, ee = Te.toString, se = F.Symbol, ce = se ? se.prototype : void 0, ie = ce ? ce.toString : void 0;
  function Ce(t) {
    return te(t) && ee.call(t) == s;
  }
  function Ae(t, n, o) {
    var m = -1, T = t.length;
    n < 0 && (n = -n > T ? 0 : T + n), o = o > T ? T : o, o < 0 && (o += T), T = n > o ? 0 : o - n >>> 0, n >>>= 0;
    for (var pe = Array(T); ++m < T; )
      pe[m] = t[m + n];
    return pe;
  }
  function fe(t) {
    if (typeof t == "string")
      return t;
    if (Ge(t))
      return ie ? ie.call(t) : "";
    var n = t + "";
    return n == "0" && 1 / t == -a ? "-0" : n;
  }
  function Ie(t, n, o) {
    var m = t.length;
    return o = o === void 0 ? m : o, !n && o >= m ? t : Ae(t, n, o);
  }
  function Ne(t, n) {
    return n = n == null ? c : n, !!n && (typeof t == "number" || g.test(t)) && t > -1 && t % 1 == 0 && t < n;
  }
  function _e(t, n, o) {
    if (!te(o))
      return !1;
    var m = typeof n;
    return (m == "number" ? Re(o) && Ne(n, o.length) : m == "string" && n in o) ? Le(o[n], t) : !1;
  }
  function Le(t, n) {
    return t === n || t !== t && n !== n;
  }
  function Re(t) {
    return t != null && Oe(t.length) && !$e(t);
  }
  function $e(t) {
    var n = te(t) ? ee.call(t) : "";
    return n == y || n == d;
  }
  function Oe(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= c;
  }
  function te(t) {
    var n = typeof t;
    return !!t && (n == "object" || n == "function");
  }
  function je(t) {
    return !!t && typeof t == "object";
  }
  var xe = x ? v(x) : Ce;
  function Ge(t) {
    return typeof t == "symbol" || je(t) && ee.call(t) == h;
  }
  function Pe(t) {
    return t == null ? "" : fe(t);
  }
  function De(t, n, o) {
    return o && typeof o != "number" && _e(t, n, o) && (n = o = void 0), o = o === void 0 ? i : o >>> 0, o ? (t = Pe(t), t && (typeof n == "string" || n != null && !xe(n)) && (n = fe(n), !n && le(t)) ? Ie(Ee(t), 0, o) : t.split(n, o)) : [];
  }
  e.exports = De;
})(ae, ae.exports);
const Ze = ae.exports, u = {
  IDLE: "idle",
  TYPING: "typing",
  ERASING: "erasing",
  COMPLETE: "complete"
}, I = {
  BACKSPACE: "backspace",
  SELECT_BACK: "select-back",
  SELECT_ALL: "select-all",
  CLEAR: "clear"
}, Qe = oe({
  name: "VueTyper",
  components: { Char: He, Caret: Xe },
  props: {
    text: {
      type: [String, Array],
      required: !0,
      validator(e) {
        return typeof e == "string" ? e.length > 0 : e.every((r) => typeof r == "string" && r.length > 0);
      }
    },
    repeat: {
      type: Number,
      default: () => 1 / 0,
      validator: (e) => e >= 0
    },
    shuffle: {
      type: Boolean,
      default: () => !1
    },
    initialAction: {
      type: String,
      default: () => u.TYPING,
      validator: (e) => !!e.match(`^${u.TYPING}|${u.ERASING}$`)
    },
    preTypeDelay: {
      type: Number,
      default: () => 70,
      validator: (e) => e >= 0
    },
    typeDelay: {
      type: Number,
      default: () => 70,
      validator: (e) => e >= 0
    },
    preEraseDelay: {
      type: Number,
      default: () => 2e3,
      validator: (e) => e >= 0
    },
    eraseDelay: {
      type: Number,
      default: () => 250,
      validator: (e) => e >= 0
    },
    eraseStyle: {
      type: String,
      default: () => I.SELECT_ALL,
      validator: (e) => Object.keys(I).some((a) => I[a] === e)
    },
    eraseOnComplete: {
      type: Boolean,
      default: () => !1
    },
    caretAnimation: String
  },
  emits: ["typedChar", "typed", "erased", "completed"],
  setup(e, { emit: r }) {
    const a = b(u.IDLE), c = b(null), i = b([]), y = b(-1), d = b(-1), s = b(-1), h = b(0), g = b(0), p = b(0), E = f(() => !!e.eraseStyle.match(`^${I.SELECT_BACK}|${I.SELECT_ALL}$`)), V = f(() => {
      const l = a.value === u.IDLE;
      return {
        idle: l,
        "pre-type": l && c.value === u.TYPING,
        "pre-erase": l && c.value === u.ERASING,
        typing: a.value === u.TYPING,
        selecting: a.value === u.ERASING && E.value,
        erasing: a.value === u.ERASING && !E.value,
        complete: a.value === u.COMPLETE
      };
    }), q = f(() => ({
      selected: a.value === u.ERASING && E.value,
      erased: a.value !== u.ERASING || a.value === u.ERASING && !E.value
    })), Q = f(() => !!e.eraseStyle.match(`^${I.CLEAR}|${I.SELECT_ALL}$`)), C = f(() => s.value >= S.value), A = f(() => E.value ? s.value <= 0 && d.value <= 0 : s.value <= 0), K = f(() => y.value === i.value.length - 1), P = f(() => h.value < e.repeat), _ = f(() => {
      const l = G(y);
      return l >= 0 && l < G(i).length ? G(i)[l] : "";
    }), L = f(() => Ze(_.value, "")), S = f(() => L.value.length), D = f(() => s.value < 0 ? 0 : s.value), z = f(() => S.value - D.value);
    ne(() => e.text, (l, v) => {
      l === v || Ve(l, v) || M();
    }), ne(() => e.repeat, () => M()), ne(() => e.shuffle, () => M()), ke(() => {
      H();
    }), we(() => {
      R();
    });
    function H() {
      if (typeof e.text == "string")
        i.value = [e.text];
      else {
        let l = e.text.slice();
        l = l.filter((v) => v.length > 0), i.value = l;
      }
      h.value = 0, J(), e.initialAction === u.TYPING ? O() : e.initialAction === u.ERASING && (w(), j());
    }
    function M() {
      R(), H();
    }
    function J() {
      y.value = 0, e.shuffle && i.value.length > 1 && qe(i.value);
    }
    function R() {
      p.value && (clearInterval(p.value), p.value = 0), g.value && (clearTimeout(g.value), g.value = 0);
    }
    function k(l) {
      d.value = s.value;
      const v = s.value + l;
      s.value = Math.min(Math.max(v, 0), S.value);
    }
    function $() {
      d.value = s.value, s.value = 0;
    }
    function w() {
      d.value = s.value, s.value = S.value;
    }
    function F() {
      if (!C.value) {
        k(1);
        const l = d.value, v = L.value[l];
        r("typedChar", v, l);
      }
      C.value && (R(), de(j));
    }
    function Y() {
      A.value || (Q.value ? $() : k(-1)), A.value && (R(), de(B));
    }
    function O() {
      g.value || p.value || ($(), a.value = u.IDLE, c.value = u.TYPING, g.value = setTimeout(() => {
        a.value = u.TYPING, F(), C.value || (p.value = setInterval(F, e.typeDelay));
      }, e.preTypeDelay));
    }
    function W() {
      g.value || p.value || (w(), a.value = u.IDLE, c.value = u.ERASING, g.value = setTimeout(() => {
        a.value = u.ERASING, Y(), A.value || (p.value = setInterval(Y, e.eraseDelay));
      }, e.preEraseDelay));
    }
    function j() {
      r("typed", G(_)), G(K) ? e.eraseOnComplete || G(P) ? W() : x() : W();
    }
    function B() {
      r("erased", _.value), K.value ? P.value ? (h.value++, J(), O()) : x() : (y.value++, O());
    }
    function x() {
      a.value = u.COMPLETE, c.value = null, r("completed");
    }
    return {
      numLeftChars: D,
      currentTextArray: L,
      caretClasses: V,
      numRightChars: z,
      rightCharClasses: q,
      currentTextLength: S,
      currentTextIndex: s,
      state: a,
      moveCaretToStart: $,
      moveCaretToEnd: w,
      shiftCaret: k,
      typeStep: F,
      onTyped: j,
      onErased: B,
      onComplete: x
    };
  }
}), et = { class: "vue-typer" }, tt = { class: "left" }, nt = { class: "right" };
function rt(e, r, a, c, i, y) {
  const d = ve("Char"), s = ve("Caret");
  return N(), U("span", et, [
    ye("span", tt, [
      (N(!0), U(he, null, ge(e.numLeftChars, (h) => (N(), me(d, {
        class: "typed",
        char: e.currentTextArray[h - 1]
      }, null, 8, ["char"]))), 256))
    ]),
    Fe(s, {
      class: Z(e.caretClasses),
      animation: e.caretAnimation
    }, null, 8, ["class", "animation"]),
    ye("span", nt, [
      (N(!0), U(he, null, ge(e.numRightChars, (h) => (N(), me(d, {
        char: e.currentTextArray[e.numLeftChars + h - 1],
        class: Z(e.rightCharClasses)
      }, null, 8, ["char", "class"]))), 256))
    ])
  ]);
}
const re = /* @__PURE__ */ ue(Qe, [["render", rt]]);
re.install = function(e) {
  e.component(re.name, re);
};
export {
  re as Typer,
  re as default
};
